<template>
  <section class="flex h-full flex-col items-center justify-center gap-y-4">
    <wui-icon
      data-test="list-plug-icon"
      class="h-[100px]! w-[100px]! text-primary-tints-300!"
      :name="icon"
    />
    <p
      data-test="list-plug-text"
      class="text-1316 font-light text-primary text-center px-2"
    >
      {{ text }}
    </p>
    <slot />
  </section>
</template>

<script setup lang="ts">
import { IconName, WuiIcon } from '@wui/common-library'

defineProps<{
  text: string,
  icon: IconName,
}>()
</script>
